import { createFirebaseApp } from '@lotushealth/web_kit/firebase';

import { ENV } from '../../config/env.js';

export const firebaseApp = createFirebaseApp(ENV);
